module.exports = function view (state, actions) {
  return h('div', { class: 'section' }, [
    h('div', { class: 'columns' }, [
      h('div', { class: 'column is-one-fifth' }, [
        'Counter max:',
        h('input', { type: 'number', value: (state.counterMax), class: 'input', onchange: function (e) { actions.setCounterMax(+this.value) } })
      ]),
      h('div', { class: 'column is-two-fifths' }, [
        'Counter:',
        h('x-counter', { max: (state.counterMax) })
      ])
    ]),
    h('x-profile', { id: '' }),
    h('x-profile', { id: '' }),
    h('x-profile', { id: '' })
  ])
}
